"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function UpThin(props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("polygon", { fill: "currentColor", points: "4.91 5.606 4.91 13.106 12.41 13.106 12.41 14.106 3.91 14.106 3.91 5.606", transform: "scale(1 -1) rotate(-45 -15.633 0)" })));
}
exports.default = UpThin;
//# sourceMappingURL=UpThin.js.map